'use client';

import { MappingText, mappingTextTag } from '@ni/nimble-components/dist/esm/mapping/text';
import { wrap } from '../../utilities/react-wrapper';

export { mappingTextTag };
export { type MappingText };
export const NimbleMappingText = wrap(MappingText);
